export enum RenewalActions {
  RenewCurrent = "renew-current",
  RenewLatest = "renew-latest",
  RemoveData = "remove-data",
}

export interface RenewalQueryParams {
  orderItemId: string;
  renewalEmailId: string;
  action: RenewalActions;
}

export interface RenewalEmail {
  id: string;
  email: string;
  emailType: string;
  sent: string;
  deliverySuccess: boolean;
  linkClickedTime?: string;
}
